import React from "react";

const Terms: React.FC = () => {
  return (
    <div>
      <h1 className="mt-16 md:mt-24 text-center mb-0 mx-auto max-w-screen-md">
        SocialBoat: Terms of Use
      </h1>
      <iframe
        src="https://notioniframe.com/notion/1w71lasi5se"
        className="  scrollbar-hide"
        style={{ width: "100%", height: "100vh", border: 0 }}
      />
    </div>
    // <div className="flex items-center justify-center text-gray-700">
    //   <div className="py-10 ">
    //     <h3 className="pb-2 text-3xl font-bold text-white">
    //       Terms and Privacy policy
    //     </h3>
    //     <div className={"space-y-4"}>
    //       <p>
    //         <strong>TERMS OF USE</strong>
    //       </p>
    //       <p>
    //         <strong>[Last Updated Date: 05 March, 2020]</strong>
    //       </p>
    //       <p>
    //         VISITORS TO THIS PLATFORM ARE BOUND BY THE FOLLOWING TERMS OF USE ({" "}
    //         <strong>"TERMS"</strong> ) AND THE PRIVACY POLICY. YOU ARE REQUESTED
    //         TO CAREFULLY READ THE TERMS AND CONDITIONS MENTIONED HEREIN BEFORE
    //         CONTINUING TO ACCESS OUR WEBSITE, LOCATED AT{" "}
    //         <a href="https://www.inspirock.com/">
    //           <em>www.holidaying.travel</em>
    //         </a>
    //         , APPLICATION FOR MOBILE AND HANDHELD DEVICES (COLLECTIVELY
    //         HEREINAFTER CALLED AS THE " <strong>PLATFORM</strong>") AND USE THE
    //         TRIP PLANNING SERVICES ACCESSIBLE VIA THE PLATFORM AND VIA
    //         THIRD-PARTY WEBSITES. WITH RESPECT TO THE TERMS AND THE PRIVACY
    //         POLICY, YOU SHALL BE DEEMED TO HAVE READ, UNDERSTOOD AND CONSENTED
    //         TO THE SAME ON YOUR FREE WILL.
    //       </p>
    //       <p>
    //         Welcome to the webpage of{" "}
    //         <strong>HTT Holidaying Travel Technologies Pvt Ltd</strong>.
    //         (hereinafter referred to as " <strong>we</strong>", "{" "}
    //         <strong>us</strong>", " <strong>Company</strong>" or "{" "}
    //         <strong>Holidaying</strong>"). Our mission is to help you discover
    //         the planet the right way.
    //       </p>
    //       <p>
    //         The Terms are between the Company and registered users of the
    //         Platform (hereinafter referred to as " <strong>you</strong>", "{" "}
    //         <strong>your</strong>" or " <strong>User</strong>") and describe the
    //         terms on which the Company offers you access to the Platform and the
    //         services availed through use of the Platform (the "{" "}
    //         <strong>Services</strong>").
    //       </p>
    //       <p>
    //         The Terms are an electronic record in terms of the Information
    //         Technology Act, 2000, the applicable rules thereunder (as amended
    //         from time to time) and the provisions pertaining to electronic
    //         records in various statutes as amended by the Information Technology
    //         Act, 2000 and are published in accordance with the provisions of
    //         Rule 3(1) of the Information Technology (Intermediaries Guidelines)
    //         Rules, 2011. This electronic record is generated by a computer
    //         system and does not require any physical or digital signature.
    //       </p>
    //       <p>
    //         While the Terms will apply to your use of the Platform, there may be
    //         additional terms (such as the terms imposed by mobile application
    //         stores like Apple's iTunes, Android's Play Store, Microsoft's store
    //         from time to time) which will govern the use of the Platform. These
    //         additional terms to the extent applicable are hereby deemed to be
    //         incorporated in the Terms and Privacy Policy by way of reference.
    //       </p>
    //       <p>
    //         PLEASE READ THE TERMS CAREFULLY. IF YOU DO NOT AGREE WITH ANY OF THE
    //         TERMS OR CONDITIONS, DO NOT ACCESS OR OTHERWISE USE THE PLATFORM OR
    //         ANY INFORMATION CONTAINED ON THE PLATFORM. YOUR ACCEPTANCE OF THE
    //         TERMS CONSTITUTES YOUR AGREEMENT TO ABIDE BY EACH OF THE TERMS AND
    //         CONDITIONS SET FORTH BELOW:
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Acceptance</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         By accessing the Platform and using the Services, you acknowledge
    //         and agree to be bound by the terms and conditions stated below as
    //         part of the Terms, and otherwise contained on or referenced in the
    //         Platform. If you do not agree to the Terms, you are not authorized
    //         to access the Platform and/ or use the Services. If you are
    //         accessing the Platform and/ or using the Services on behalf of a
    //         company (such as your employer) or other legal entity, you represent
    //         and warrant that you have the authority to bind that company or
    //         other legal entity to the Terms. In such an event, "{" "}
    //         <strong>you</strong>" and " <strong>your</strong>" will refer to
    //         such company or other legal entity.
    //       </p>
    //       <p>
    //         You also acknowledge and agree that, unless we specifically provide
    //         otherwise, the Terms only apply to the Platform and our online
    //         activities, and does not apply to any of our offline activities.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Privacy Policy</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Terms include and incorporate the Privacy Policy (as available
    //         at{" "}
    //         <a href="https://www.inspirock.com/privacy-policy">
    //           <em>www.holidaying.travel/privacy-policy</em>
    //         </a>
    //         ), which is integrated herein by reference.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Changes to Terms or Services</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         You also acknowledge and agree that we may modify the Terms at any
    //         time, in our sole discretion; that all modifications to the Terms
    //         will be effective immediately upon our posting of the modifications
    //         on the Platform; and that you will review the Terms each time you
    //         access the Platform, so that you are aware of and agree to any and
    //         all modifications made to the Terms. Use of the Platform after
    //         updates are posted and effective constitutes acceptance of any
    //         changes.
    //       </p>
    //       <p>
    //         If you do not agree to be bound by the modified Terms, then, as
    //         stated above, you are authorised to access the Platform and/ or use
    //         the Services. This is light of the fact that the Services are
    //         evolving over time wherein the Company may choose to either modify
    //         the scope or discontinue all or any part of the Services, at any
    //         time and without notice, at its sole discretion.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Who May Use the Services</strong>
    //         </li>
    //         <li>Eligibility</li>
    //       </ol>
    //       <p>
    //         The use of the Services is available only to those individuals and
    //         body corporates who can enter into legally binding contracts under
    //         applicable law.
    //       </p>
    //       <p>
    //         If you are a minor i.e. under the age of 18 (eighteen) years but at
    //         least 13 (thirteen) years of age or above you may use the Platform
    //         either under the supervision of your legal guardian, such legal
    //         guardian who has agreed to be bound by the Terms and Privacy Policy.
    //       </p>
    //       <p>
    //         By using the Platform you warrant and confirm that you have the
    //         legal right, authority and capacity to enter into and be bound by
    //         the Terms and the Privacy Policy.
    //       </p>
    //       <ol>
    //         <li>Registration and Your Information</li>
    //       </ol>
    //       <p>
    //         If the User wishes to use certain features of the Platform and/ or
    //         the Services, the User is required to create an account ("{" "}
    //         <strong>Account</strong>") via the Platform or through an account
    //         with certain third-party social networking services such as Facebook
    //         (" <strong>SNS Account</strong>"). In the event the User chooses the
    //         SNS Account option the Platform will create your Account by
    //         extracting from the SNS Account certain personal information such as
    //         the User's name and email address and other personal information
    //         that the privacy settings on the SNS Account permit the Platform to
    //         access.
    //       </p>
    //       <p>
    //         For certain function of the Services, such as reviewing and tracking
    //         your use of the Services or to provide effective Service through the
    //         Platform, you may be required to provide your name, age, mobile or
    //         phone number, and/or address; without limiting the generality of
    //         foregoing, you are required to provide accurate and complete
    //         information.
    //       </p>
    //       <p>
    //         You acknowledge and agree that you shall provide us with accurate,
    //         complete and up-to-date information for your Account and you agree
    //         to update such information, as needed, to keep it accurate, complete
    //         and up-to-date. In the event you do not comply by the requirement as
    //         mentioned herein, we shall have the right to suspend or terminate
    //         your Account. You agree that you shall not disclose your Account
    //         password to anyone and you shall notify us immediately of any
    //         unauthorized use of your Account. You shall, at all time, be
    //         responsible for all activities that occur under your Account,
    //         irrespective of your knowledge of the same.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Feedback</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         We welcome feedback, comments and suggestions for improvements to
    //         the Platform and/ or the Services (" <strong>Feedback</strong>").
    //         You can submit Feedback on the Platform or by emailing us at
    //         info@holidaying.co.in. You hereby agree that any non-personal
    //         information, communications and material you send to the Platform or
    //         to us by E-mail, forming part of the Feedback, are on a
    //         non-confidential basis and with respect to the same, you agree to
    //         grant to us a non-exclusive, worldwide, perpetual, irrevocable,
    //         fully-paid, royalty-free, sub-licensable and transferable right and
    //         license under any and all intellectual property rights that you own
    //         or control to use, reproduce, copy, modify, create derivative works
    //         of, distribute, or publicly display any such information freely, and
    //         for any purpose whatsoever.
    //       </p>
    //       <p>
    //         Specifically, we will be free to use any ideas, concepts, know-how
    //         or techniques contained in such information for any purpose,
    //         including developing, manufacturing or marketing products.
    //       </p>
    //       <p>
    //         You also represent and warrant that any information you send to the
    //         Platform does not violate the rights of others, and that you have
    //         full rights and authority to provide or disclosure such information
    //         on the Platform.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>
    //             Procedure For Making Copyright Infringement Claims
    //           </strong>
    //         </li>
    //       </ol>
    //       <p>
    //         We respect the intellectual property of others, and we ask you and
    //         all of the Platform users, affiliates, licensors and suppliers to do
    //         the same. If you believe that your copyrighted work has been copied
    //         and is accessible on this Platform in a way that constitutes
    //         copyright infringement, you may notify us by providing our copyright
    //         agent with all of the following information:
    //       </p>
    //       <ol>
    //         <li>
    //           The electronic or physical signature of the copyright owner, or
    //           the person or entity authorized to act on behalf of the copyright
    //           owner;
    //         </li>
    //         <li>
    //           A specific description of the copyrighted work claimed to be
    //           infringed;
    //         </li>
    //         <li>
    //           A specific description of the claimed infringing activity
    //           (including the specific web page address on the Platform);
    //         </li>
    //         <li>
    //           A specific description where the original or an authorized copy of
    //           the copyrighted work exists (including, for example, a specific
    //           web page address not on the Platform);
    //         </li>
    //         <li>Your name, address, telephone number and E-mail address;</li>
    //         <li>
    //           A written statement by you that you have a good faith belief that
    //           the disputed use is not authorized by the copyright owner, the
    //           person or entity authorized to act on behalf of the copyright
    //           owner, or the law; and
    //         </li>
    //         <li>
    //           A written statement by you, made under penalty of perjury, that
    //           all of the above information is accurate, and that you are the
    //           copyright owner or the person or entity authorized to act on
    //           behalf of the copyright owner.
    //         </li>
    //       </ol>
    //       <p>
    //         Our agent for notices of claims of copyright infringement on this
    //         Platform may be reached as follows:
    //       </p>
    //       <ol>
    //         <li>
    //           Via email on{" "}
    //           <a href="mailto:booking@holidaying.co.in">
    //             booking@holidaying.co.in
    //           </a>{" "}
    //           or{" "}
    //           <a href="mailto:tech@holidaying.co.in">tech@holidaying.co.in</a>
    //         </li>
    //         <li>
    //           <strong>Platform Content</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         You acknowledge and agree that (i) all contents, including, without
    //         limitation, text, graphics, images, music, software, audio, video,
    //         works of authorship of any kind, and information or other materials
    //         that are posted, generated, provided or otherwise made available
    //         through the Platform and any User Content (<em>as defined below</em>
    //         ) (" <strong>Content</strong>"), are protected by copyright,
    //         trademark, service mark, patent, trade secret, or other proprietary
    //         rights or laws; (ii) except as specifically permitted by the Terms,
    //         any use of such Content is strictly prohibited; (iii) except if we
    //         and/or the applicable rights holder(s) give you prior written
    //         permission, you will not sell, license, rent, modify, print, copy,
    //         reproduce, download, transmit, distribute, publicly display,
    //         publicly perform, publish, edit, adapt, compile, or create
    //         derivative works from any Content (including, without limitation,
    //         through framing or systematic retrieval to create collections,
    //         compilations, databases or directories); and (iv) except if we give
    //         you prior written permission, use of any web browsers (other than
    //         generally available third-party browsers), engines, software,
    //         spiders, robots, avatars, agents, tools, or other devices or
    //         mechanisms to navigate or search the Platform is strictly
    //         prohibited. Notwithstanding the foregoing, you may download or print
    //         single copies of such Content for your personal, non-commercial use
    //         only, provided you keep intact all copyright and other proprietary
    //         notices.
    //       </p>
    //       <p>
    //         For purposes of the Terms " <strong>User Content</strong>" shall
    //         mean any Content that the User (including you) shall provide to be
    //         made available by way of availing the Services, including how you
    //         describe and label your itineraries.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Content Ownership, Responsibility and Removal</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Company does not claim any ownership rights in any User Content
    //         and nothing in the Terms will be deemed to restrict any rights that
    //         you may have to use and exploit your User Content. Subject to the
    //         foregoing, the Company and its affiliates and licensors exclusively
    //         own all right, title and interest in and to the Services and
    //         Content, including all associated intellectual property rights. You
    //         acknowledge that the Services and Content are protected by
    //         copyright, trademark, and other laws of India and foreign countries.
    //         You agree not to remove, alter or obscure any copyright, trademark,
    //         service mark or other proprietary rights notices incorporated in or
    //         accompanying the Services or Content.
    //       </p>
    //       <ol>
    //         <li>Rights in User Content Granted by You</li>
    //       </ol>
    //       <p>
    //         By making any User Content available through Services you hereby
    //         grant to the Company a non-exclusive, transferable, worldwide,
    //         license to use, copy, modify, and distribute your User Content in
    //         connection with operating and providing the Services to you and to
    //         other Account holders.
    //       </p>
    //       <p>
    //         You hereby authorize the Company to (i) use information related to
    //         you, which is either submitted by you to contact you, (ii) maintain
    //         a record of your queries, visit of the Platform, and/or feedback,
    //         and (iii) share information related to you with the third party
    //         service providers which provide services to the users on the
    //         Platform.
    //       </p>
    //       <p>
    //         You are solely responsible for all your User Content. You represent
    //         and warrant that neither your User Content, nor your use and
    //         provision of your User Content to be made available through the
    //         Services, nor any use of your User Content by the Company on or
    //         through the Services will infringe, misappropriate or violate a
    //         third party's intellectual property rights, or rights of publicity
    //         or privacy, or result in the violation of any applicable law or
    //         regulation.
    //       </p>
    //       <p>
    //         You can remove your User Content by specifically deleting it.
    //         However, in certain instances, some of your User Content may not be
    //         completely removed and copies of your User Content may continue to
    //         exist on the Services. We are not responsible or liable for the
    //         removal or deletion of (or the failure to remove or delete) any of
    //         your User Content.
    //       </p>
    //       <ol>
    //         <li>Rights in Content Granted by the Company</li>
    //       </ol>
    //       <p>
    //         Subject to your compliance with the Terms, the Company grants you a
    //         limited, non-exclusive, non-transferable, non-sublicensable license
    //         to access and view the Content solely in connection with your
    //         permitted use of the Services and solely for your personal and
    //         non-commercial purposes.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>
    //             General Prohibitions and the Company's Enforcement Rights
    //           </strong>
    //         </li>
    //       </ol>
    //       <p>By using any of the Services you agree and acknowledge that:</p>
    //       <ol>
    //         <li>
    //           You will use any or all of the Services provided by the Company
    //           only for the purposes that are permitted by and are in accordance
    //           with (a) the Terms and Privacy Policy, and (b) any applicable law.
    //         </li>
    //         <li>
    //           All the calls made to the Company will be recorded by the Company
    //           for quality and training purposes.
    //         </li>
    //         <li>
    //           You are solely responsible for any breach of the Terms and Privacy
    //           Policy and for the consequences resulting from such breach
    //           (including any loss, damage or expense suffered or incurred by the
    //           Company or its affiliates/business partners/vendors).
    //         </li>
    //       </ol>
    //       <p>
    //         As mandated by Regulation 3(2) of the Information Technology
    //         (Intermediaries Guidelines) Rules, 2011, and to the extent it is
    //         applicable to the Terms and Privacy Policy, the Company hereby
    //         informs you that you are not permitted to host, display, upload,
    //         modify, publish, transmit, update or share any information that:
    //       </p>
    //       <ol>
    //         <li>
    //           belongs to another person and to which you do not have any right;
    //         </li>
    //         <li>
    //           is harmful, harassing, blasphemous, defamatory, obscene,
    //           pornographic, pedophilic, libelous, invasive of another's privacy,
    //           hateful, racial, ethnically objectionable, disparaging, relating
    //           to or encouraging money laundering or gambling, or otherwise
    //           unlawful in any manner whatsoever;
    //         </li>
    //         <li>harms minors in any way;</li>
    //         <li>
    //           infringes any patent, trademark, copyright or other proprietary
    //           rights;
    //         </li>
    //         <li>violates any law for the time being in force;</li>
    //         <li>
    //           deceives or misleads the addressee about the origin of such
    //           messages or communicates any information which is grossly
    //           offensive or menacing in nature;
    //         </li>
    //         <li>impersonates or defames another person;</li>
    //         <li>
    //           contains software viruses or any other computer code, files or
    //           programs designed to interrupt, destroy or limit the functionality
    //           of any computer resource; and
    //         </li>
    //         <li>
    //           threatens the unity, integrity, defence, security or sovereignty
    //           of India, friendly relations with foreign states, or public order
    //           or causes incitement to the commission of any cognisable offence
    //           or prevents investigation of any offence or is insulting to any
    //           other nation.
    //         </li>
    //       </ol>
    //       <p>You agree that you are prohibited to:</p>
    //       <ol>
    //         <li>
    //           Violate or attempt to violate the integrity or security of the
    //           Platform;
    //         </li>
    //         <li>
    //           Transmit any information on or through the Platform that is
    //           disruptive to the provision of the Services provided by the
    //           Company;
    //         </li>
    //         <li>
    //           Post, upload, publish, submit or transmit any Content that: (i)
    //           infringes, misappropriates or violates a third party's patent,
    //           copyright, trademark, trade secret, moral rights or other
    //           intellectual property rights, or rights of publicity or privacy;
    //           (ii) is fraudulent, false, misleading or deceptive; (iii) is
    //           defamatory, obscene, pornographic, vulgar or offensive; (iv) is
    //           violent or threatening or promotes violence or actions that are
    //           threatening to any person or entity; or (v) promotes illegal or
    //           harmful activities or substances;
    //         </li>
    //         <li>
    //           Use, display, mirror or frame the Services or any individual
    //           element within the Services, the Company's name, any Holidaying
    //           trademark, logo or other proprietary information, or the layout
    //           and design of any page or form contained on a page, without the
    //           Company's express written consent;
    //         </li>
    //         <li>
    //           Access, tamper with, or use non-public areas of the Services, the
    //           Company's computer systems, or the technical delivery systems of
    //           the Company's providers;
    //         </li>
    //         <li>
    //           Attempt to probe, scan or test the vulnerability of any Company
    //           system or network or breach any security or authentication
    //           measures;
    //         </li>
    //         <li>
    //           Avoid, bypass, remove, deactivate, impair, descramble or otherwise
    //           circumvent any technological measure implemented by the Company or
    //           any of the Company's providers or any other third party (including
    //           another user) to protect the Services or Content;
    //         </li>
    //         <li>
    //           Attempt to access or search the Services or Content or download
    //           Content from the Services through the use of any engine, software,
    //           tool, agent, device or mechanism (including spiders, robots,
    //           crawlers, data mining tools or the like) other than the software
    //           and/or search agents provided by the Company or other generally
    //           available third-party web browsers;
    //         </li>
    //         <li>
    //           Send any unsolicited or unauthorized advertising, promotional
    //           materials, email, junk mail, spam, chain letters or other form of
    //           solicitation;
    //         </li>
    //         <li>
    //           Use any meta tags or other hidden text or metadata utilizing a
    //           Holidaying trademark, logo URL or product name without the
    //           Company's express written consent;
    //         </li>
    //         <li>
    //           Use the Services or Content, or any portion thereof, for any
    //           commercial purpose or for the benefit of any third party or in any
    //           manner not permitted by the Terms;
    //         </li>
    //         <li>
    //           Forge any TCP/IP packet header or any part of the header
    //           information in any email or newsgroup posting, or in any way use
    //           the Services or Content to send altered, deceptive or false
    //           source-identifying information;
    //         </li>
    //         <li>
    //           Attempt to decipher, decompile, disassemble or reverse engineer
    //           any of the software used to provide the Services or Content;
    //         </li>
    //         <li>
    //           Interfere with, or attempt to interfere with, the access of any
    //           user, host or network, including, without limitation, sending a
    //           virus, overloading, flooding, spamming, or mail-bombing the
    //           Services;
    //         </li>
    //         <li>
    //           Collect or store any personally identifiable information from the
    //           Services from other users of the Services without their express
    //           permission;
    //         </li>
    //         <li>
    //           Impersonate or misrepresent your affiliation with any person or
    //           entity;
    //         </li>
    //         <li>
    //           Encourage or enable any other individual to do any of the
    //           foregoing;
    //         </li>
    //         <li>
    //           Intentionally submit on the Platform any incomplete, false or
    //           inaccurate information;
    //         </li>
    //         <li>
    //           Make any unsolicited communications to other users of the
    //           Platform;
    //         </li>
    //         <li>
    //           Attempt to decipher, decompile, disassemble or reverse engineer
    //           any part of the Platform;
    //         </li>
    //         <li>
    //           Copy or duplicate in any manner any of the information available
    //           on the Platform; and
    //         </li>
    //         <li>
    //           Frame or hotlink or deep link any Contents from the Platform.
    //         </li>
    //       </ol>
    //       <p>
    //         You acknowledge and agree that the Company shall, but shall not be
    //         obliged to, (i) monitor the access to Platform and/ or use of the
    //         Services and/ or Content and (ii) review and/ or edit any Content,
    //         for the purposes of ensuring compliance with the Terms, the Privacy
    //         Policy, and the applicable law or other legal requirements, pursuant
    //         to operation of the Platform and provision of the Services.
    //       </p>
    //       <p>
    //         The Company, upon obtaining knowledge by itself or having been
    //         brought to actual knowledge by an affected person in writing or
    //         through email about any such information as mentioned above, shall
    //         be entitled to disable such information that is in contravention of
    //         the Terms, Privacy Policy and the applicable law; and the Company
    //         shall be entitled to preserve such information and associated
    //         records for production to governmental authorities for investigation
    //         purposes.
    //       </p>
    //       <p>
    //         You acknowledge and agree that the Company shall, but shall not be
    //         obliged to, at its sole discretion, remove or terminate your or any
    //         other party's access to all or part of the Platform or any Content,
    //         at any time and without notice, including, but not limited to, any
    //         Content that the Company shall considered to be objectionable or in
    //         violation of the Terms. Without limitation of any other provisions
    //         of the Terms, we reserve the right to take any actions at law or in
    //         equity that we deem appropriate in connection with the Platform,
    //         Content and the Terms.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>DMCA/Copyright Policy</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Company respects copyright law and expects its Users to do the
    //         same. It is the Company's policy to terminate in appropriate
    //         circumstances including but not limited to events when Users
    //         repeatedly infringe or are believed to be repeatedly infringing the
    //         rights of relevant copyright holders. Please see our Copyright and
    //         IP Policy (available at{" "}
    //         <a href="https://www.inspirock.com/copyright-policy">
    //           <em>www.holidaying.travel/copyright-policy</em>
    //         </a>
    //         ), which is integrated herein by reference.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Links to Third Party Websites or Resources</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         You acknowledge and agree that, unless we specifically provide
    //         otherwise, any links on this Platform to third party sites do not
    //         imply our endorsement of such sites or that we have any association
    //         whatsoever with the operators of such sites; that such sites are not
    //         under our control; and that we are not responsible for any materials
    //         (including, without limitation, any content, data, software,
    //         information, products or services) contained on or provided through
    //         such sites, or the appropriateness, decency, legality, copyright
    //         compliance, accuracy or any other aspect of such sites.
    //       </p>
    //       <p>
    //         We are not responsible for the content, products or services on or
    //         available from those websites or resources or links displayed on
    //         such websites. You acknowledge sole responsibility for and assume
    //         all risk arising from, your use of any third-party websites or
    //         resources.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Google Terms of Use</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         Holidaying Service uses Google. By using our Service, you are bound
    //         by{" "}
    //         <a href="https://www.google.com/intl/en/policies/terms">
    //           <em>Google's Terms of Service</em>
    //         </a>
    //         .
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Termination</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Usershall have the right to delete its PII and Account by
    //         following the process as prescribed on the Platform. The User may
    //         also request us to do the same by sending a request at 602, 6th
    //         Floor, Galleria Towers, Gurgaon, 122018 with proof of the User's
    //         identity. Upon any termination, discontinuation or cancellation of
    //         Services and/ or the User's Account, the following provisions of the
    //         Terms will survive: Content Ownership, Warranty Disclaimers,
    //         Limitations of Liability, and Dispute Resolution.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Warranty Disclaimers</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         YOU ACKNOWLEDGE AND AGREE THAT USE OF THE PLATFORM, THE SERVICES AND
    //         CONTENT ARE AT YOUR OWN RISK, AND ARE PROVIDED ON "AS IS," AND "AS
    //         AVAILABLE" BASIS; THAT WE DO NOT MAKE ANY EXPRESS OR IMPLIED
    //         WARRANTIES, REPRESENTATIONS OR ENDORSEMENTS OF ANY KIND WITH REGARD
    //         TO THE PLATFORM OR ANY CONTENT THEREON, INCLUDING, WITHOUT
    //         LIMITATION, WARRANTIES OF TITLE, NONINFRINGEMENT, MERCHANTABILITY,
    //         FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR
    //         NON-INFRINGEMENT, AND ANY WARRANTIES ARISING OUT OF COURSE OF
    //         DEALING OR USAGE OF TRADE.
    //       </p>
    //       <p>
    //         YOU ALSO ACKNOWLEDGE AND AGREE THAT WE DO NOT WARRANT OR REPRESENT
    //         THAT THE PLATFORM, THE SERVICES OR ANY CONTENT THEREON WILL BE
    //         ACCURATE, RELIABLE, CORRECT, USEFUL, TIMELY, UNINTERRUPTED, SECURE,
    //         DEFECT-FREE OR ERROR-FREE (INCLUDING, WITHOUT LIMITATION, FREE FROM
    //         VIRUSES, WORMS, TROJANS, OTHER MALICIOUS CODE OR OTHER HARMFUL
    //         COMPONENTS). WE MAKE NO WARRANTY REGARDING THE QUALITY, ACCURACY,
    //         TIMELINESS, TRUTHFULNESS, COMPLETENESS OR RELIABILITY OF ANY
    //         CONTENT. IN JURISDICTIONS NOT ALLOWING THE EXCLUSION OR LIMITATION
    //         OF CERTAIN WARRANTIES, OUR AND OUR SUBSIDIARIES, AFFILIATES,
    //         LICENSORS AND SUPPLIERS LIABILITY WILL BE LIMITED TO THE EXTENT
    //         PERMITTED BY LAW.
    //       </p>
    //       <p>
    //         You acknowledge and agree that certain actual conditions may differ
    //         from the Content available via the Platform. For example, you may
    //         find that the hours or location of a particular event or historical
    //         site are not exactly as listed on the Platform. We do not guarantee
    //         that the Services and Content are entirely accurate nor can we
    //         consider every concern a User may have when visiting an unfamiliar
    //         area. You should exercise your own independent judgment when using
    //         the Services to plan your trip. You expressly acknowledge and agree
    //         that, at all times, you are responsible for your conduct and its
    //         consequences.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Indemnity</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         You acknowledge and agree that you will indemnify and hold harmless
    //         the Company and its subsidiaries, successors, assigns, affiliates,
    //         licensors and suppliers, together with all of their officers,
    //         directors, employee and agents, from and against any and all claims,
    //         disputes, demands, liabilities, damages, losses, judgments and costs
    //         and expenses, including, without limitation, reasonable legal and
    //         accounting fees and costs arising out of or in any way connected
    //         with (a) your access to or use/ misuse of the Platform, Services
    //         and/ or Content, (b) your User Content, or (c) your violation of the
    //         Terms, any laws, rules or regulations. You also acknowledge and
    //         agree that we reserve the right to exclusively defend and control
    //         any such indemnification matters and that you will fully cooperate
    //         with us in any such defenses.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Limitation of Liability</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         YOU ACKNOWLEDGE AND AGREE THAT IN NO EVENT WILL WE AND/ OR OUR
    //         SUBSIDIARIES, AFFILIATES, LICENSORS AND/OR SUPPLIERS, INVOLVED IN
    //         CREATING, PRODUCING, OR DELIVERING THE SERVICES OR CONTENT, BE
    //         LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
    //         CONSEQUENTIAL, PUNITIVE OR ANY OTHER DAMAGES, RELATING TO THE USE,
    //         MISUSE OR INABILITY TO USE THE PLATFORM OR ANY CONTENT (WHETHER
    //         BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE,
    //         AND EVEN IF WE AND/OR OUR SUBSIDIARIES, AFFILIATES, LICENSORS AND/OR
    //         SUPPLIERS HAS OR HAVE BEEN ADVISED OF A POSSIBILITY OF DAMAGES),
    //         INCLUDING BUT NOT LIMITED TO LOST PROFITS, LOSS OF DATA OR GOODWILL,
    //         SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST
    //         OF SUBSTITUTE SERVICES ARISING OUT OF OR IN CONNECTION WITH THESE
    //         TERMS OR FROM THE USE OF OR INABILITY TO USE THE SERVICES OR
    //         CONTENT, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING
    //         NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND
    //         WHETHER OR NOT THE COMPANY HAS BEEN INFORMED OF THE POSSIBILITY OF
    //         SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO
    //         HAVE FAILED OF ITS ESSENTIAL PURPOSE. IN JURISDICTIONS NOT ALLOWING
    //         THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES,
    //         OUR AND OUR SUBSIDIARIES, AFFILIATES, LICENSORS AND SUPPLIERS
    //         LIABILITY WILL BE LIMITED TO THE EXTENT PERMITTED BY LAW.
    //       </p>
    //       <p>
    //         YOU ALSO ACKNOWLEDGE AND AGREE THAT IF YOU ARE DISSATISFIED WITH, OR
    //         CLAIM ANY DAMAGES RELATING TO, ANY PORTION OF THE PLATFORM, ANY
    //         CONTENT OR THE TERMS, YOUR SOLE AND EXCLUSIVE REMEDY IS TO
    //         DISCONTINUE USING THE PLATFORM AND ALL CONTENT ON THE PLATFORM.
    //       </p>
    //       <p>
    //         IN NO EVENT WILL THE COMPANY'S TOTAL LIABILITY ARISING OUT OF OR IN
    //         CONNECTION WITH THE TERMS OR FROM THE USE OF OR INABILITY TO USE THE
    //         SERVICES OR CONTENT EXCEED THE AMOUNTS YOU HAVE PAID OR ARE PAYABLE
    //         BY YOU TO THE COMPANY FOR USE OF THE SERVICES OR CONTENT OR USD 100
    //         (UNITED STATES DOLLAR ONE HUNDRED ONLY), IF YOU HAVE NOT HAD ANY
    //         PAYMENT OBLIGATIONS TO THE COMPANY, AS THE CASE MAY BE.
    //       </p>
    //       <p>
    //         THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE
    //         FUNDAMENTAL ELEMENTS AND THE BASIS OF THE BARGAIN BETWEEN THE
    //         COMPANY AND YOU.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Governing Law and Jurisdiction</strong>
    //         </li>
    //         <li>Governing Law and Forum</li>
    //       </ol>
    //       <p>
    //         The Terms, the Privacy Policy and your use of the Platform and/ or
    //         the Services shall be governed by the laws of India, including
    //         without limitation the Indian Contract Act, 1872, Information
    //         Technology Act, 2000 and the rules, regulations, guidelines and
    //         clarifications framed thereunder (including the Information
    //         Technology (Reasonable Security Practices and Procedures and
    //         Sensitive Personal Information) Rules, 2011 and the Information
    //         Technology (Intermediaries Guidelines) Rules, 2011) and without
    //         reference to principles of conflicts of law. Subject to the dispute
    //         resolution clause below, courts and tribunals of New Delhi, India
    //         shall have exclusive jurisdiction to settle any dispute arising out
    //         of or in connection with the Terms, including but not limited to any
    //         disputes regarding the existence, validity or termination of the
    //         Terms. You expressly consent to the jurisdiction of the said
    //         courts/tribunal and irrevocably waive any objection now or in
    //         future, to such jurisdiction based on forum non convenience or any
    //         other basis.
    //       </p>
    //       <ol>
    //         <li>Jurisdictional Limitations</li>
    //       </ol>
    //       <p>
    //         Laws and regulatory requirements vary across countries and
    //         jurisdictions. The Platform may not comply with legal requirements
    //         of all jurisdictions. You acknowledge and agree that if you are
    //         located in any jurisdiction in the world where any common,
    //         statutory, regulatory, codified or other law, rule or regulation
    //         makes accessing the Platform or any Content inappropriate or
    //         illegal, or subject to consents or permissions that you yourself
    //         have not obtained, or voids the Terms in whole or in part, then you
    //         are not authorized to access the Platform or any Content.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Dispute Resolution</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         If any dispute, controversy or claim arises under, out of, or in
    //         relation to the Terms, including any dispute concerning the
    //         formation, construction, interpretation, or breach of the Terms or
    //         any party's performance of its obligations under it, such dispute
    //         shall at the first instance be attempted to be resolved through
    //         mutual good faith consultations. If the dispute is not resolved in
    //         this manner within 45 (forty five) days of either party sending a
    //         notice to the other party of such dispute, then the dispute shall be
    //         resolved by binding arbitration under the provisions of the
    //         Arbitration &amp; Conciliation Act 1996, by a sole arbitrator in New
    //         Delhi, India.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Notices</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         All notices or demands to or upon the Company shall be effective if
    //         in writing and shall be deemed to be duly made when sent to: HTT
    //         Holidaying Travel Technologies, at 602, 6th Floor, Galleria Towers,
    //         Gurgaon, 122018 or by email to info@holidaying.co.in. All notices or
    //         demands to or upon a member shall be effective if either delivered
    //         personally, sent by courier, certified mail, by facsimile or email
    //         to the last known correspondence, fax or email address provided by
    //         the member on the Platform, or by posting such notice or demand on
    //         an area of the Platform that is publicly accessible. Notice to a
    //         member shall be deemed to be received by such member if and when the
    //         Platform is able to demonstrate that communication, whether in
    //         physical or electronic form, has been sent to such member, or
    //         immediately upon Platform's posting such notice on an area of the
    //         Platform that is publicly accessible.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Entire Agreement</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Terms constitute the entire agreement between the Company, its
    //         affiliates and you in connection with your use of the Platform, the
    //         Services and the Content and it supersedes all prior or
    //         contemporaneous communications and proposals, whether electronic,
    //         oral or written, between the User and the Company with respect to
    //         the Platform, the Services and the Content. Any cause of action you
    //         may have with respect to your use of the Platform, the Services or
    //         the Content must be commenced within 1 (one) year after the claim or
    //         cause of action arises. If for any reason an arbitrator or a court
    //         of competent jurisdiction finds any provision of these Terms or
    //         portion thereof, to be unenforceable, that provision shall be
    //         enforced to the maximum extent permissible so as to effect the
    //         intent of these Terms, and the remainder of the Terms shall continue
    //         in full force and effect.
    //       </p>
    //       <p>
    //         The Terms will be deemed to include all other notices, policies,
    //         disclaimers and other terms contained in the Platform and in other
    //         contracts that you may have executed with the Company and its
    //         affiliates.
    //       </p>
    //       <p>
    //         A printed version of the Terms and/ or of any notice given in
    //         electronic form shall be admissible in judicial or administrative
    //         proceedings based upon or relating to the Terms to the same extent
    //         and subject to the same conditions as other business documents and
    //         records originally generated and maintained in printed form. It is
    //         the express wish to the parties that the Terms and all related
    //         documents be drawn up in English.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Severability</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The failure of the Company to exercise or enforce any right or
    //         provision of the Terms does not constitute a waiver of such right or
    //         provision. You acknowledge and agree that (a) if any provision of
    //         the Terms is held by any court or other tribunal of competent
    //         jurisdiction to be not enforceable, then such provision will be
    //         eliminated or limited to the minimum extent necessary so that the
    //         Terms will otherwise remain in full force and effect; (b) the Terms
    //         constitute the entire agreement between you and us relating to the
    //         subject matter hereof, and supersedes any and all prior agreements
    //         or understandings between you and us, whether oral or written,
    //         relating to any subject matter of the Terms; (c) the Terms may not
    //         be modified, in whole or in part, except by us and as otherwise
    //         might be specifically described elsewhere in the Terms; and (d)
    //         anything contained on or provided through the Platform that is
    //         inconsistent with or conflicts with the terms of the Terms is
    //         superseded by the terms of the Terms.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Miscellaneous</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         Headings for any section of the Terms are for reference purposes
    //         only and in no way define, limit, construe or describe the scope or
    //         extent of such section.
    //       </p>
    //       <p>
    //         The Company shall have the right to assign its obligations and
    //         duties in the Terms to any person or entity.
    //       </p>
    //       <p>
    //         All telephonic calls to the Company will be kept completely
    //         confidential. However, your call may be recorded to ensure quality
    //         of service. Further, for training purposes and to ensure excellent
    //         customer service, calls from the Company to the User or from the
    //         User to the Company may be monitored and/or recorded.
    //       </p>
    //       <p>
    //         <strong>Swapnil Vats</strong> is the designated Grievance Officer in
    //         respect of the Platform. Any complaints or concerns with regards to
    //         any Content on the Platform or any breach of the Terms or Privacy
    //         Policy can be directed to the designated Grievance Officer in
    //         writing at: HTT Holidaying Travel Technologies, at 602, 6th Floor,
    //         Galleria Towers, Gurgaon, 122018 or through an email signed with
    //         electronic signatures sent to info@holidaying.co.in. We agree to use
    //         our good faith and reasonable endeavors to take necessary action(s)
    //         andremove any abusive Content and/ or User which shall be identified
    //         to be in violation of the aforementioned Terms, within 24 (twenty
    //         four) hours of being notified of the same.
    //       </p>
    //       <p>
    //         <strong>PRIVACY POLICY</strong>
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>INTRODUCTION</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Company understands and recognizes your right to confidentiality
    //         and is committed to protecting and preserving your privacy. The
    //         Privacy Policy forms an integral part of the Terms. Subject to the
    //         provisions of this Privacy Policy and applicable law, the Company
    //         may collect, receive, store, deal in, handle and share Personal
    //         Information (<em>as defined hereinafter</em>) including Sensitive
    //         Personal Data (<em>as defined hereinafter</em>) pertaining to the
    //         Users of the Platform. The Company is committed to safeguarding the
    //         privacy, confidentiality and security of such Personal Information
    //         of the Users. The Privacy Policy outlines the information the
    //         Company may process and/or use to improve the User experience while
    //         using the Platform. Pursuant to such commitment, the Company has
    //         developed the Privacy Policy for the handling of or for dealing in
    //         the aforementioned information. Reference to ' <strong>you</strong>'
    //         in the Privacy Policy refers to the Users of the Platform.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>THE PERSONAL INFORMATION WE COLLECT</strong>
    //         </li>
    //         <li>For the purposes of this Privacy Policy,</li>
    //         <li>
    //           " <strong>Force Majeure Event</strong>" shall mean any event that
    //           is beyond our reasonable control and shall include, without
    //           limitation, sabotage, fire, flood, explosion, act of God, civil
    //           commotion, strikes or industrial action of any kind, riots,
    //           insurrection, war, acts of government, computer hacking,
    //           unauthorized access to your mobile or storage device, crashes,
    //           breach of security and encryption.
    //         </li>
    //         <li>
    //           " <strong>Personal Information</strong>" means any information
    //           relating to the Users which, either directly or indirectly, in
    //           combination with other information available or likely to be
    //           available with the Company, is capable of identifying such Users
    //           and includes Sensitive Personal Data (<em>as defined below</em>)
    //           of the User.
    //         </li>
    //         <li>
    //           " <strong>Sensitive Personal Data</strong>" in relation to a User
    //           means personal data or information of a User which consists of
    //           information relating to:-
    //         </li>
    //         <li>password;</li>
    //         <li>
    //           financial information such as bank account or credit card or debit
    //           card or other payment instrument details;
    //         </li>
    //         <li>physical, physiological and mental health condition;</li>
    //         <li>sexual orientation;</li>
    //         <li>medical records and history;</li>
    //         <li>biometric information;</li>
    //         <li>
    //           any detail relating to the above clauses as provided to the
    //           Company for providing service; and
    //         </li>
    //         <li>
    //           any information received under the above clauses by the Company
    //           for processing, or stored or processed under lawful contract or
    //           otherwise:
    //         </li>
    //       </ol>
    //       <p>
    //         provided that, any information that is freely available or
    //         accessible in public domain or furnished under the Right to
    //         Information Act, 2005 or any other law for the time being in force
    //         shall not be regarded as Sensitive Personal Data or Personal
    //         Information for the purposes of this Privacy Policy.
    //       </p>
    //       <ol>
    //         <li>
    //           " <strong>Third Party</strong>" refers to any person or entity
    //           other than you or us.
    //         </li>
    //         <li>
    //           <strong>
    //             PURPOSES OF COLLECTING, STORING AND USING YOUR PERSONAL DATA AND
    //             THE MANNER OF SUCH USAGE
    //           </strong>
    //         </li>
    //         <li>
    //           Typically, the Personal Information collected by the Company
    //           includes all information and data that is required by the Company
    //           for providing the Services and may include (without limitation)
    //           one or more of the following: name, e-mail and residential
    //           address, telephone number(s), bank account or credit card or debit
    //           card or other payment instrument details, academic details and any
    //           other related information of the Users. Further, we may be
    //           required to disclose such Personal Information to Third Parties in
    //           connection with the Services and in accordance with the terms and
    //           conditions stipulated by such Third Parties.
    //         </li>
    //         <li>
    //           In order to provide you a safe, efficient, smooth and customized
    //           experience and in order to take advantage of certain features
    //           available on the Platform, you will be asked to verify the
    //           personal information provided to the Company by means of your User
    //           Content.
    //         </li>
    //         <li>
    //           We may also collect the information that is not Personal
    //           Information, that you provide as part of registration and
    //           personalization of your account profile. The Company may use your
    //           Personal Information, including your Sensitive Personal Data for
    //           the purposes mentioned herein below:
    //         </li>
    //         <li>
    //           <strong>Optimization of Customer Service</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         When you register as a User, we will collect your name, email
    //         address, mobile phone number, internet protocol (IP) address, device
    //         information, etc. We will use your contact details to send you a
    //         welcome email/short message service (" <strong>SMS</strong>") to
    //         communicate with you in response to your inquiries, and to send you
    //         announcements related to the Services, for instance, if the Service
    //         is temporarily suspended for maintenance. We may also contact you to
    //         conduct research about your opinion of the Services or of potential
    //         new services that may be offered. We will use your registration
    //         information to create and manage your user account. We may
    //         deactivate your account if we suspect that you use the Platform to
    //         commit fraudulent or illegal acts or if you violate the User Terms.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>Communication</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         We may offer email, Platform notifications, SMS, multimedia message
    //         service ( <strong>MMS</strong> ) or other forms of communication to
    //         share information with you about certain promotions or features the
    //         Platform may choose to offer or about our affiliates, subsidiaries,
    //         business partners, advertisers and sponsors. You may receive such
    //         communication when you have registered as a user of the Platform.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>HOW WE USE COOKIES</strong>
    //         </li>
    //         <li>
    //           A cookie is a small file which asks permission to be placed on
    //           your computer's hard drive. Once you agree, the file is added and
    //           the cookie helps analyze web traffic or lets you know when you
    //           visit a particular site. Cookies allow web applications to respond
    //           to you as an individual. The web application can tailor its
    //           operations to your needs, likes and dislikes by gathering and
    //           remembering information about your preferences.
    //         </li>
    //         <li>
    //           We use traffic log cookies to identify which pages are being used.
    //           This helps us analyze data about webpage traffic and improve the
    //           Platform in order to tailor it to customer needs. We only use this
    //           information for statistical analysis purposes and then the data is
    //           removed from the system.
    //         </li>
    //         <li>
    //           Overall, cookies help us provide you with a better Platform, by
    //           enabling us to monitor which pages you find useful and which you
    //           do not. A cookie in no way gives us access to your computer or any
    //           information about you, other than the data you choose to share
    //           with us. You can choose to accept or decline cookies. Most web
    //           browsers automatically accept cookies, but you can usually modify
    //           your browser setting to decline cookies if you prefer. Please
    //           refer to your web-browser provider or system guide for detailed
    //           information on disabling cookies. However, in case you choose to
    //           disable the cookies, you may be prevented from taking full
    //           advantage of the Platform.
    //         </li>
    //         <li>
    //           <strong>LINKS TO THIRD PARTY APPS AND WEBSITES</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         The Platform and any communication sent to you may contain/display
    //         Third Party advertisements and links to other websites/mobile
    //         applications of interest. However, once you have used any of these
    //         links to leave the Platform, you should note that we do not have any
    //         control over that other website(s)/mobile application(s). You agree
    //         and acknowledge that these websites/mobile applications are operated
    //         by Third Parties and are not controlled by, or affiliated to, or
    //         associated with us unless expressly specified. We are not
    //         responsible for any form of transmission, whatsoever, received by
    //         you from any such Third Party. Accordingly, we do not make any
    //         representations concerning the privacy practices or policies of such
    //         Third Parties or terms of use of such websites or mobile
    //         applications, nor do we control or guarantee the accuracy,
    //         integrity, or quality of the information, data, text, software,
    //         music, sound, photographs, graphics, videos, messages or other
    //         materials available on such websites or mobile applications.
    //         Therefore, we cannot be responsible for the protection and privacy
    //         of any information, which you provide whilst visiting such
    //         sites/mobile applications and this Privacy Policy does not govern
    //         such sites/mobile applications. You should exercise caution and look
    //         at the privacy statement applicable to the website(s)/mobile
    //         application(s) in question. The information provided by you to such
    //         Third Party websites/mobile applications shall be governed in
    //         accordance with the privacy policies of such websites/mobile
    //         applications and it is recommended that you review the privacy
    //         policy on any such websites and/or mobile applications prior to
    //         using such websites/mobile applications.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>SECURITY OF PERSONAL INFORMATION</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         We will take reasonable technical and organizational precautions to
    //         prevent the loss, misuse or alteration of your Personal information,
    //         this includes storing all your Personal Information, including
    //         Sensitive Personal Data you provide on our secure servers. By
    //         agreeing to this policy and using the Platform or other interactive
    //         services you acknowledge that the transmission of information over
    //         the internet is inherently insecure, and we cannot guarantee the
    //         security of data sent over the internet. You are responsible for
    //         keeping the password you use for accessing the Platform
    //         confidential; we will never ask you to send us your password (except
    //         for the standard log in procedure on the Platform). Notwithstanding
    //         anything contained in this Privacy Policy or elsewhere, we shall not
    //         be held responsible for any loss, damage or misuse of your Personal
    //         Information, if such loss, damage or misuse is attributable to a
    //         Force Majeure Event.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>SHARING OF PERSONAL INFORMATION</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         Notwithstanding anything contained in this Privacy Policy, we may
    //         release your Personal Information when we believe such release is
    //         appropriate to comply with applicable law, enforce the Platform
    //         policies or the Terms, or for protecting our or others rights,
    //         property or and/or for ensuring safety.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>CHANGES IN THIS PRIVACY POLICY</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         We may update this Privacy Policy to reflect changes to our
    //         information practices and applicable laws. If we make any material
    //         changes we will notify you by email and by means of a notice on the
    //         Platform prior to the change becoming effective. We encourage you to
    //         periodically review this page for the latest information on our
    //         privacy practices.
    //       </p>
    //       <ol>
    //         <li>
    //           <strong>CONTACTING US</strong>
    //         </li>
    //       </ol>
    //       <p>
    //         If there are any questions regarding the Privacy Policy you may
    //         contact us at{" "}
    //         <a href="mailto:tech@holidaying.co.in">tech@holidaying.co.in</a> or
    //         <a href="mailto:booking@holidaying.co.in">
    //           booking@holidaying.co.in
    //         </a>
    //         .
    //       </p>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Terms;
